import {Flex, Image} from "antd";
import {Fade} from "react-awesome-reveal";
import img15 from "../../About/images/15.jpg";
import MyText from "../../../components/UI/Text/MyText";
import {clrs} from "../../../constants/colors";
import HorizontalDivider from "../../../components/Divider/HorizontalDivider";
import {Link} from "react-router-dom";
import {LinkOutlined} from "@ant-design/icons";
import React from "react";

export const Person15 = () => {
    return (
        <Flex style={{ width: "100%", position: "relative" }} vertical gap={20}>
            <Flex style={{ width: "100%", position: "relative" }} gap={40}>
                <Fade triggerOnce={true} cascade damping={0.15}>
                    <Image src={img15} width={300} preview={false} style={{ borderRadius: 20 }} />
                </Fade>

                <Flex style={{ width: "100%", position: "relative" }} vertical>
                    <MyText strong size={"large"}>
                        Кириченко Лалита Николаевна
                    </MyText>
                    <MyText style={{ color: clrs.whiterBlacker }}>
                        Bachelor of Automation and Control, Master of Technical Sciences, PhD Student of Automation and Control
                    </MyText>
                    <br />
                    <HorizontalDivider />
                    <br />
                    <Flex gap={20} wrap={"wrap"} vertical>
                        <Link target={"_blank"} to={'https://www.scopus.com/authid/detail.uri?authorId=57219992844'}>
                            <MyText><LinkOutlined /> Scopus</MyText>
                        </Link>
                        <Link target={"_blank"} to={'http://orcid.org/0000-0001-7069-5395'}>
                            <MyText><LinkOutlined /> ORCID</MyText>
                        </Link>
                    </Flex>
                    <br />
                    <MyText strong size={"small"}>
                        Основное место работы, должность
                    </MyText>
                    <MyText>
                        ТОО "Astana IT University", младший научный сотрудник, НИЦ "Industry 4.0"
                    </MyText>
                </Flex>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Роль в проекте или программе, а также характер выполняемой работы</MyText>
                <MyText size={"small"} italic>
                    Младший научный сотрудник
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Совместное проведение экспериментальных исследований;
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Написание научных статей;
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Создание моделей облачной архитектуры программного комплекса с использованием микросервисов.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Краткое обоснование участия</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    Докторант по теме «Разработка конвергентной автоматической системы мониторинга технического состояния строительных конструкций». Имеет опыт в COMSOL, MatLab, MathCAD, владеет навыками компьютерного моделирования.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Научные проекты, в которых принимала участие:</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Участие в проекте грантового финансирования на 2022-2024 гг. ИРН AP13067967 «Разработка технологии построения микропроцессорных ресурсосберегающих устройств релейной защиты на основе открытой архитектуры». Роль –исполнитель. Проект завершен.
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Участвует в проекте грантового финансирования на 2023-2025 гг. ИРН AP19678773 «Разработка технологии интеллектуальной предварительной обработки аэрокосмических изображений для распознавания и идентификации различных объектов». Роль –исполнитель.
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Участвует в проекте программно-целевого финансирования на 2023-2025 гг. ИРН BR21882258 «Разработка комплекса интеллектуальных информационно-коммуникационных систем для экологического мониторинга эмиссий в окружающую среду для принятия решения в концепте углеродной нейтральности». Роль –исполнитель.
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Участвует в проекте программно-целевого финансирования на 2024-2026 гг. ИРН BR24993128 «Разработка информационно-аналитической системы для принятия решений, обеспечивая эффективное использование трансграничных водных ресурсов в сельскохозяйственной отрасли Жамбылского региона». Роль –исполнитель.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Роль в достижении результатов проекта:</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Совместное проведение экспериментальных исследований;
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Написание научных статей;
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Моделирование архитектуры ПО на базе микросервисов.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size="small">Публикации по теме проекта:</MyText>

                <MyText size="small" style={{ paddingLeft: 20 }}>
                    1. Neftissov, A., Sarinova, A., Kazambayev, I., Kirichenko, L., Kuchanskyi, O., Faizullin, A.  Determination of the speed of a microprocessor relay protection device of open architecture with a reed switch and the industrial internet of things. Eastern- European Journal of Enterprise Technologies, 2 (9 (122)), 20–30. doi: https://doi.org/10.15587/1729-4061.2023.276588 (published). Scopus квартиль - Q3, процентиль - 47.
                </MyText>
                <MyText size="small" style={{ paddingLeft: 20 }}>
                    2. Mekhtiyev A, Neshina Y, Alkina A, Yugay V, Kalytka V, Sarsikeyev Y, Kirichenko L. Developing an Intelligent Fiber-Optic System for Monitoring Reinforced Concrete Foundation Structure Damage. Applied Sciences. 2023; 13(21):11987. https://doi.org/10.3390/app132111987 [Scopus] Квартиль Q2
                </MyText>
                <MyText size="small" style={{ paddingLeft: 20 }}>
                    3. Mekhtiyev, Ali & Dunayev, Pavel & Neshina, Y. & Alkina, Aliya & Aimagambetova, Raushan & Mukhambetov, Gabit & Kirichenko, Lalita & Kazambayev, Ilyas. (2023). Power supply via fiber-optical conductor for sensors of mine working monitoring system. Eastern-European Journal of Enterprise Technologies. 5. 15-23. 10.15587/1729-4061.2023.289775. [Scopus] Квартиль Q3
                </MyText>
                <MyText size="small" style={{ paddingLeft: 20 }}>
                    4. Determination of changes in the parameters of reed switches in resource-saving relay protection devices of the electrical part of power plants / A.V. Neftisov, O.M. Talipov, O.A. Andreeva, L.N. Kirichenko // Journal of Physics: Conference Series. – 2022. 2211 (1). № 012017. (DOI:10.1088/1742-6596/2211/1/012017), [Scopus] процентиль 22.
                </MyText>
                <MyText size="small" style={{ paddingLeft: 20 }}>
                    5. Neftissov, A., Sarinova, A., Kazambayev, I., Kirichenko, L., Kuchanskyi, O., Faizullin, A.  Determination of the speed of a microprocessor relay protection device of open architecture with a reed switch and the industrial internet of things. Eastern- European Journal of Enterprise Technologies, 2 (9 (122)), 20–30. doi: https://doi.org/10.15587/1729-4061.2023.276588 (published). [Scopus] квартиль - Q3, процентиль - 47.
                </MyText>
                <MyText size="small" style={{ paddingLeft: 20 }}>
                    6. A.V. Neftisov, A. Zh Sarinova, O.M Talipov, L. N Kirichenko, I. M. Kazambaev. Possibility of building microprocessor relay protection devices on open architecture. Торайғыров университетінің хабаршысы. ISSN 2710-3420. Энергетикалық сериясы. № 3. 2022. Pp.277-292. DOI:10.48081/RKWX7770. КОКСОН МНиВО РК.
                </MyText>
                <MyText size="small" style={{ paddingLeft: 20 }}>
                    7. Biloshchytskyi, A., Kuchansky, A., Andrashko, Y., Neftissov, A., Vatskel, V., Yedilkhan, D., Herych, M. BUILDING A MODEL FOR CHOOSING A STRATEGY FOR REDUCING AIR POLLUTION BASED ON DATA PREDICTIVE ANALYSIS. (2022) Eastern-European Journal of Enterprise Technologies, 3 (4-117), pp. 23-30. DOI: 10.15587/1729-4061.2022.259323 [Scopus] Квартиль Q3/ Процентиль 47.
                </MyText>
                <MyText size="small" style={{ paddingLeft: 20 }}>
                    8. A. Mekhtiev, A. Alkina, A. Neftissov, I. Kazambayev and L. Kirichenko, "Intelligent Systems for Monitoring the Integrity of Technical Objects Based on Distributed Fiber-optic Sensors", CEUR Workshop Proceedings, vol. 3347, pp. 290-306, 2022. [Scopus] Процентиль 21.
                </MyText>
                <MyText size="small" style={{ paddingLeft: 20 }}>
                    9. A. Mekhtiev, A. Alkina, A. Neftissov, I. Kazambayev and L. Kirichenko, "Development of an Automatic System for Monitoring the Integrity of Power Cables Using Quasi-Distributed Fiber-Optic Sensors", CEUR Workshop Proceedings, vol. 3347, pp. 53-68, 2022. Процентиль 21.
                </MyText>
                <MyText size="small" style={{ paddingLeft: 20 }}>
                    10. Neftissov, A.; Biloshchytskyi, A.; Kazambayev, I.; Kirichenko, L.; Zhalmagambetova, U.; Biloshchytska, S. Analysis of the Existing Air Emissions Detection Methods for Stationary Pollution Sources Monitoring. Appl. Sci. 2024, 14, 10934. https://doi.org/10.3390/app142310934 [Scopus] Квартиль Q2
                </MyText>
            </Flex>
        </Flex>
    );
}